export const getPodcastSearchResults = state => state.entities.podcastSearch.results || [];
export const isPodastSearchLoading = state => state.entities.podcastSearch.isLoading;
export const getPodcastSearchError = state => state.entities.podcastSearch.error || null;
